import { render, staticRenderFns } from "./AdjustWish.vue?vue&type=template&id=16320779&scoped=true&"
import script from "./AdjustWish.vue?vue&type=script&lang=js&"
export * from "./AdjustWish.vue?vue&type=script&lang=js&"
import style0 from "./AdjustWish.vue?vue&type=style&index=0&id=16320779&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16320779",
  null
  
)

export default component.exports